import { ArrayValue, isString } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { requiredNonEmptyString, validatePayload, } from '../../utils/validate-payload.js';
const nonEmptyArray = new ArrayValue({
    each: requiredNonEmptyString,
    required: true,
});
const nonEmptyPayload = (contextKey, contextValue) => {
    validatePayload(contextKey, requiredNonEmptyString);
    if (isString(contextValue)) {
        validatePayload(contextValue, requiredNonEmptyString);
    }
    else {
        validatePayload(contextValue, nonEmptyArray);
    }
    return { payload: { contextKey, contextValue } };
};
export const setContext = createAction('context/set', (payload) => {
    for (const [k, v] of Object.entries(payload)) {
        nonEmptyPayload(k, v);
    }
    return { payload };
});
export const addContext = createAction('context/add', (payload) => nonEmptyPayload(payload.contextKey, payload.contextValue));
export const removeContext = createAction('context/remove', (payload) => validatePayload(payload, requiredNonEmptyString));
